module.exports = __webpack_public_path__ + "fonts/b3ba703.ttf";